import { faChartPie, faFileAlt } from '@fortawesome/free-solid-svg-icons'
import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../Auth/AuthContext'
import { LanguageContext } from '../Language/LanguageContext'
import { Container, TabButton } from '../Library'
import { BrowserRouter, Route } from 'react-router-dom'
import './Linkroom.css'
import UserLinkroom from './UserLinkroom'
import Bookings from './Bookings'
import Rooms from './Rooms'
import UserCreate from './UserCreate'
import { Switch } from 'react-router-dom'
import { setDocumentTitle } from '../AppTitle'
import { Form } from 'react-bootstrap'
import { listCompany } from '../Network/Company'
import { NotifyContext } from '../Library/Notify'
import axios from 'axios'

function Linkroom() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.linkroom
    const authCx = useContext(AuthContext)

    const [companyList, setCompanylist] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [chooseCompany, setChooseCompany] = useState();
    const [token, setToken] = useState("");
    const notifyCx = useContext(NotifyContext)

    const fetchList = () =>{
        setLoading(false)
        /*
        listCompany(
            (data)=>{
                if(localStorage.getItem("building_id") == 5){
                    setChooseCompany('Waveplace')
                }else{
                    setChooseCompany(data[0].name)
                    setCompanylist(data)
                }
                console.log(data)
                

                setLoading(false)
            }, 
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            }
        )*/
    }

    useEffect( async ()=>{
        setDocumentTitle("Linkroom")
        console.log(localStorage.getItem("usernames"))
        const formData = new FormData();
            formData.append('username', localStorage.getItem("usernames"));
        const authResponse = await axios.post('https://visitor-api.lifelink.co.th:10443/linkroom/api/v1/authen_lifelink', formData);
        setToken(authResponse.data.data.token)
        console.log(authResponse.data.data.token)
        /*
        console.log(localStorage.getItem("building_id"))
        listCompany(
            (data)=>{
                if(localStorage.getItem("building_id") == 5){
                    setChooseCompany(data[21].name)
                }else{
                    setChooseCompany(data[0].name)
                    setCompanylist(data)
                }
                setLoading(false)
            },
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            }
        )*/
        fetchList()
    },[])



    return (
        <Container topbarTitle={lang.linkroom}>
            <BrowserRouter basename='/linkroom'>
                <div className='nav-container'>
                    <div className='nav-left'>
                        <TabButton title={lang.bookings} icon={faChartPie} to='/' exact={true}/>
                        <TabButton title={lang.users} icon={faFileAlt} to='/users'/>
                        <TabButton title={lang.rooms} icon={faChartPie} to='/rooms'/>
                    </div>
                </div>
                <hr/>
                <Switch>
                    <Route path="/" render={(props) => <Bookings {...props} token={token} />} exact>
                    </Route>
                    <Route path="/users" render={(props) => <UserLinkroom {...props} token={token} />}  exact>
                    </Route>
                    <Route path="/users/create" render={(props) => <UserCreate {...props} token={token}/>} >
                    </Route>
                    <Route path="/rooms" render={(props) => <Rooms {...props} token={token} />} exact>
                    </Route>
                </Switch>
            </BrowserRouter>
        </Container>
    )
}


export default Linkroom
